import { ReactElement } from 'react';

import { DashboardVariantV2CarrierZoneSaturationContainer } from './styles';
import DashboardVariantV2CarrierZoneSaturationHeader from './Header';
import DashboardVariantV2CarrierZoneSaturationCollapse from './Collapse';

const DashboardVariantV2CarrierZoneSaturation = (): ReactElement => (
  <DashboardVariantV2CarrierZoneSaturationContainer>
    <DashboardVariantV2CarrierZoneSaturationHeader />

    <DashboardVariantV2CarrierZoneSaturationCollapse />
  </DashboardVariantV2CarrierZoneSaturationContainer>
);

export default DashboardVariantV2CarrierZoneSaturation;
